import router from './../router'

/**
 * Formatter helper
 */
class Formatter {
  formatPrice (value) {
    let val = (value / 1).toFixed(2).replace('.', ',')
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  }

  makeLink (name, link) {
    return '<a href="' + link + '" target="_blank">' + name + '</a>'
  }

  makeSelect2List (list, key, value) {
    let result = []
    for (let i in list) {
      result.push({
        id: list[i][key],
        text: list[i][value]
      })
    }
    return result
  }

  formatPercent (value) {
    let result = parseFloat(value)
    if (result < 1) {
      result = result * 100
    }
    return result.toFixed(2)
  }

  formatFlowStatus (status) {
    let result = status.replace(/[\W]/g, '').replace(/[-_]/g, ' ').replace(/\s+/, ' ')
    result = result.toLowerCase().charAt(0).toUpperCase() + result.slice(1)
    return result
  }

  formatModel (modelObject) {
    if (typeof modelObject !== 'object') {
      return modelObject
    }

    if (typeof modelObject.class === 'undefined') {
      return null
    }

    switch (modelObject.class) {
      case 'common\\models\\Sale':
        return this.formatSale(modelObject.model || null)

      case 'common\\models\\file\\ModelFileSlot':
        return 'slot ' + modelObject.title
    }
  }

  formatSale (saleObject, asHtml = true) {
    if (typeof saleObject !== 'object') {
      return saleObject
    }

    if (asHtml) {
      return this.makeLink('sale #' + saleObject.id, router.resolve({
        name: 'sale.details',
        params: { 'oid': saleObject.id }
      }).href)
    } else {
      return 'sale #' + saleObject.id
    }
  }

  formatUser (userObject) {
    if (userObject && typeof userObject === 'object') {
      if (userObject.hasOwnProperty('profile')) {
        if (userObject.profile.first_name || userObject.profile.last_name) {
          let res = userObject.profile.first_name + ' ' + userObject.profile.last_name
          if (res.length > 1) {
            return res
          }
        }
      }

      if (userObject.hasOwnProperty('email')) {
        return userObject.email
      }
    }
    return userObject
  }

  formatDateTime (dateTime, format = 'short') {

  }

  __makeMap (source, compare) {
    let _res = {}
    for (let i in source) {
      _res[i] = compare === source[i]
    }
    return _res
  }
}

const formatter = new Formatter()
export default formatter
